/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

angular.module('common.filter.measuretype.description', ['common.config', 'common.filter.description']).filter('measureTypeDescription', function($filter,  CONSTANTS){
    return function(measureType) {
        if (!measureType){
            return null;
        }
        var measureTypeDescription = $filter('description')(measureType.descriptions);
        if (CONSTANTS.showMeasureTypeCode){
            measureTypeDescription = measureTypeDescription + " (" + measureType.id + ")";
        }
        return measureTypeDescription;
  };
});



// WEBPACK FOOTER //
// ./app/common/filter/measuretype-description-filter.js